import { Link } from "react-router-dom";

export default function ErrorInfo({ message = "Something went wrong", details = null }) {
  return (
    <div className="page-navbar-space container">
      <div className="d-flex align-items-center justify-content-center flex-column">
        <h1 className="display-1 fw-bold text-danger text-center">Oops!</h1>
        <h2 className="display-5 text-center fw-semibold">{message}</h2>
        {details && <p className="lead text-muted text-center fw-medium">{details}</p>}
        <Link to="/" className="btn btn-primary  btn-lg mt-4">
          Go Home
        </Link>
      </div>
    </div>
  )
}
